<script>
import { getCookie } from '@/helpers/cookies';

export default {
  name: 'VetsterContentAuthGate',

  mounted() {
    this.trackEvent('content_gate_load');
  },

  methods: {
    trackClick() {
      return this.trackEvent('content_gate_click');
    },
    trackEvent(eventName) {
      this.$analytics.track({
        eventName,
        uat_id: getCookie('v-uatid'),
        parent: 'content-page',
        child: 'content-gate',
        type: 'blog',
      });

      return true;
    },
  },
};
</script>
